import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
name: 'materialCompare',
components: {
XHeader, Group, XNumber, Popup, Checker, CheckerItem, XButton,
},
data () {
return {

roundValue:1,

timePopup: false,
}
},
methods: {

timeSelect(){
if(this.timePopup) {
this.timePopup = false;
}else{
this.timePopup = true;
}
},
},

created() {

},
}



// WEBPACK FOOTER //
// ./src/views/materialCompare/script.js